module.exports = __webpack_public_path__ + "dingbeauty-landing/img/img_manage.4b42ebee.png";